export default {"src":"/_next/static/media/empowered_ownership.403092b0.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};